import ModuleTranslations from "./ModuleTranslations";
import { getTranslatedDefinition } from "../../utils";
import { BASE_URL } from "../../../request";
import SortDirection from "react-virtualized/dist/commonjs/Table/SortDirection";

const ModuleDefinition = {
  name: "Properties",
  entityName: "properties",
  filterFields: [
    "ticker",
    "status",
    ["frontEndActivated", "bool"],
    ["backOfficeActivated", "bool"],
    "group",
    "partner",
    "currency",
    "country",
    ["created", "daterange"],
    ["updated", "daterange"],
    ["startContractPeriod", "daterange"],
    ["endContractPeriod", "daterange"],
  ],
  restConfig: {
    baseURL: `${BASE_URL}`,
    dataField: "content",
    fetch: {
      url: ({ id }) => `api/crm/properties${id ? "/" + id : "?size=10000"}`,
      method: "get",
    },
    update: {
      url: ({ id }) => `api/crm/properties/${id}`,
      method: "put",
    },
  },
  entities: [],
  renderers: {
    list: {},
    form: {},
  }, //render functions by attribute name, this overrides default widgets specified in the fields section
  translation: {
    translated: true,
    fieldName: "translations",
    displayName: "translations",
    widget: "translations",
    entityProperty: "translations",
  },
  allowCreate: false,
  allowDelete: false,
  allowClone: false,
  allowExport: true,
  exportFileName: "crm_properties_export",
  sorting: {
    property: "ticker",
    sortable: true,
    sortDirection: SortDirection.ASC,
  },
  reorder: false,
  showTotalRecords: true,
  fields: {
    list: [
      {
        fieldName: "id",
        widget: "hidden",
      },
      {
        fieldName: "ticker",
        displayName: "Ticker",
        width: 300,
      },
      {
        fieldName: "clients",
        displayName: "CLI",
        width: 100,
      },
      {
        fieldName: "numContracts",
        displayName: "#Cont.",
        width: 60,
      },
      {
        fieldName: "frontEndActivated",
        displayName: "Frontend",
        width: 80,
      },
      {
        fieldName: "backOfficeActivated",
        displayName: "Backoffice",
        width: 80,
      },
      {
        fieldName: "group",
        displayName: "Grupo",
        width: 80,
      },
      {
        fieldName: "partner",
        displayName: "Partner",
        width: 100,
        visible: ({ userInfo }) => userInfo.isWitAdmin,
      },
      {
        fieldName: "rooms",
        displayName: "Rooms",
        width: 80,
      },
      {
        fieldName: "currency",
        displayName: "Div.Motor",
        width: 80,
      },
      {
        fieldName: "country",
        displayName: "País",
        width: 80,
      },
      {
        fieldName: "status",
        displayName: "Status",
        width: 80,
      },
      {
        fieldName: "created",
        displayName: "Creado",
        width: 100,
      },
      {
        fieldName: "updated",
        displayName: "Modificado",
        width: 100,
      },
      {
        fieldName: "startContractPeriod",
        displayName: "Inicia",
        width: 100,
      },
      {
        fieldName: "endContractPeriod",
        displayName: "Final",
        width: 100,
      },
    ],
    form: [
      {
        fieldName: "demo",
        displayName: "EsDemo",
        widget: "singleSwitch",
        order: 10,
        disabled: ({ entity, formValues }) => {
          const actualEntity =
            (entity && entity.content && entity.content.find(e => e.id === formValues.id)) || {};
          return actualEntity.demo;
        },
      },
      {
        fieldName: "frontEndActivated",
        displayName: "Frontend",
        widget: "singleSwitch",
        order: 20,
      },
      {
        fieldName: "backOfficeActivated",
        displayName: "Backoffice",
        widget: "singleSwitch",
        order: 30,
      },
      {
        fieldName: "ticker",
        displayName: "Ticker",
        widget: "input",
        readOnly: true,
        order: 40,
      },
      {
        fieldName: "group",
        displayName: "Grupo",
        widget: "input",
        order: 50,
      },
      {
        fieldName: "partner",
        displayName: "Partner",
        // TODO: <select> with list of partners given by backoffice
        widget: "selector",
        defaultValue: "C2T",
        optionDisplay: window.wbkPartnersList || {
          C2T: {
            label: "C2T",
          },
          WIT: {
            label: "WIT",
          },
        },
        order: 60,
      },
      {
        fieldName: "rooms",
        displayName: "Rooms",
        widget: "input",
        order: 70,
      },
      {
        fieldName: "currency",
        displayName: "Divisa Motor",
        widget: "selector",
        defaultValue: "EUR",
        optionDisplay: {
          EUR: {
            label: "EUR",
          },
          USD: {
            label: "USD",
          },
          COP: {
            label: "COP",
          },
        },
        order: 80,
      },
      {
        fieldName: "country",
        displayName: "País",
        widget: "input",
        order: 90,
      },
    ],
  },
  validation: {
    name: {
      type: "String",
      constraints: {
        presence: {
          allowEmpty: false,
        },
      },
    },
    rooms: {
      type: "Number",
      constraints: {
        numericality: {
          onlyInteger: true,
        },
        presence: {
          allowEmpty: false,
        },
      },
    },
  },
};

export default ({ locale }) =>
  getTranslatedDefinition({ ModuleDefinition, ModuleTranslations, locale });
